import { render, staticRenderFns } from "./select_bank_modal.vue?vue&type=template&id=06f1248c&scoped=true&"
import script from "./select_bank_modal.vue?vue&type=script&lang=js&"
export * from "./select_bank_modal.vue?vue&type=script&lang=js&"
import style0 from "./select_bank_modal.vue?vue&type=style&index=0&id=06f1248c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f1248c",
  null
  
)

export default component.exports